import { configCounts } from '@/services/xverdict_config_mapper';
import { badge_class_for_domain } from './case_domains_badge_helpers';
import {
  first_count,
  first_value,
  normalize_key,
  normalize_text,
  to_array,
  to_number
} from './case_domains_common';

const CLOSED_STATUSES = new Set([
  'closed', 'complete', 'completed', 'cancelled', 'canceled', 'declined', 'rejected'
]);

function entity_type_name(entity_type = {}) {
  return normalize_text(first_value([
    entity_type?.entity_type_name,
    entity_type?.entity_type_label,
    entity_type?.domain_name,
    entity_type?.domain,
    entity_type?.entity_type,
    entity_type?.name,
    entity_type?.label
  ]));
}

function profile_status(profile = {}) {
  return normalize_text(first_value([
    profile?.application_status,
    profile?.application_status_name,
    profile?.current_status_name,
    profile?.workflow_status_name,
    profile?.status_name,
    profile?.status,
    'Open'
  ]));
}

function is_open_profile(profile) {
  return !normalize_key(profile_status(profile))
    .split('-')
    .some((status) => CLOSED_STATUSES.has(status));
}

function format_date(value) {
  if (!value) return 'recently';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return normalize_text(value);
  return date.toLocaleDateString('en-ZA', { day: '2-digit', month: 'short' });
}

function updated_by(config_data, entity_type) {
  const user = first_value([
    config_data?.entity_config?.updated_by,
    config_data?.entity_config?.created_by,
    entity_type?.updated_by,
    entity_type?.created_by
  ]) || {};
  const full_name = [user?.first_name, user?.last_name].filter(Boolean).join(' ').trim();
  return normalize_text(first_value([
    full_name, user?.name, user?.full_name, user?.email,
    entity_type?.updated_by_name, 'System'
  ]));
}

export function count_fields(config_data = {}) {
  const counts = configCounts(config_data);
  return first_count([
    counts.fields_count,
    counts.form_count,
    config_data?.entity_config?.fields_count,
    config_data?.entity_config?.field_count,
    config_data?.fields_count
  ]);
}

export function map_domain(entity_type, index, config_data = {}, profiles = []) {
  const id = to_number(entity_type?.id);
  const name = entity_type_name(entity_type) || `Entity type ${entity_type?.id}`;
  const config = config_data?.entity_config || {};
  const counts = configCounts(config_data);
  const updated_at = first_value([
    config.date_updated,
    config.updated_at,
    entity_type?.date_updated,
    entity_type?.updated_at,
    entity_type?.date_created
  ]);
  return {
    id,
    name,
    entity_type_id: id,
    open_count: profiles.filter(is_open_profile).length,
    fields_count: count_fields(config_data),
    rules_count: first_count([
      config.rules_count,
      config.rule_count,
      config_data?.rules_count,
      counts.rule_count,
      to_array(config_data?.rule_bindings).length
    ]),
    version: domain_version(config, entity_type, id, index),
    last_edit: format_date(updated_at),
    updated_by: updated_by(config_data, entity_type),
    badge_class: badge_class_for_domain(name, index)
  };
}

function domain_version(config, entity_type, id, index) {
  return normalize_text(config.version || entity_type?.version || `V${id || index + 1}.0`);
}
